import type { ReactNode } from 'react'
import css from './Text.module.css'

interface TextMiddProps {
    children: ReactNode
    className?: string
}

const TextMidd = ({ children, className }: TextMiddProps) => {
    return <span className={[css.midd, className].filter(Boolean).join(' ')}>{children}</span>
}

export default TextMidd
